import Role from "enums/Role";
import { useCheckUserRole } from "hooks/useCheckUserRole";

// Mirrors sendPersonalBankAccountEmail's @auth: Manager and above, but not the read-only Auditor or Accountant.
export const useCanManageUsers = (): boolean => {
  const isManagerOrHigher = useCheckUserRole(Role.Manager);
  const isAuditor = useCheckUserRole(Role.Auditor, { exact: true });
  const isAccountant = useCheckUserRole(Role.Accountant, { exact: true });
  return isManagerOrHigher && !isAuditor && !isAccountant;
};
